'use client';

import SectionError from '@/containers/Jobs/components/Sections/SectionError/SectionError';
import { selectIsNoAgentResponder } from '@/containers/Jobs/redux/jobEditors.selectors';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

interface AssignedAgentsValidationMessageProps {
  className?: string;
  jobId: string;
}

const AssignedAgentsValidationMessage = ({
  className,
  jobId,
}: AssignedAgentsValidationMessageProps) => {
  const isNoAgentResponder = useSelector(selectIsNoAgentResponder(jobId));
  if (!isNoAgentResponder) {
    return null;
  }
  return (
    <SectionError
      className={classNames('', className)}
      error="At least one agent must be marked as a responder."
    />
  );
};

export default AssignedAgentsValidationMessage;
